import { Link } from 'react-router-dom';

export default function CTASection() {
  return (
    <section className="px-4 md:px-6 py-10 md:py-14">
      <div
        className="max-w-[1280px] mx-auto rounded-2xl overflow-hidden relative h-[280px] md:h-[340px] flex items-center justify-center"
        style={{
          backgroundImage: `url(https://readdy.ai/api/search-image?query=A%20warm%20and%20inviting%20Chinese%20style%20reading%20nook%20with%20soft%20lighting%2C%20bookshelves%2C%20and%20comfortable%20seating%2C%20cozy%20atmosphere%2C%20warm%20amber%20and%20cream%20tones%2C%20cinematic%20wide%20composition%2C%20high%20quality%20photography&width=1600&height=700&seq=cta-bg-01&orientation=landscape)`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
        }}
      >
        <div className="absolute inset-0 bg-gradient-to-r from-black/50 to-black/30" />
        <div className="relative z-10 text-center px-6 w-full">
          <h2 className="font-heading text-2xl md:text-4xl font-bold text-background-50 mb-3">开始你的漫画之旅</h2>
          <p className="text-sm md:text-base text-background-200/90 max-w-md mx-auto mb-6">
            海量高清漫画，每日更新不断，随时随地享受阅读的乐趣
          </p>
          <div className="flex items-center justify-center gap-3 flex-wrap">
            <Link
              to="/category/shaonian"
              className="px-6 py-3 rounded-full bg-primary-500 text-background-50 text-sm font-medium hover:bg-primary-600 transition-all whitespace-nowrap cursor-pointer"
            >
              立即探索
            </Link>
            <Link
              to="/about"
              className="px-6 py-3 rounded-full bg-background-50/20 text-background-50 border border-background-50/30 text-sm font-medium hover:bg-background-50/30 transition-all whitespace-nowrap cursor-pointer"
            >
              了解更多
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}